// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__hVZhJ","link":"footer_link__mVK9P"};